import React from 'react';

export default function LogoLuna() {
  return (
    <svg viewBox="0 0 153.45833 153.45834" version="1.1" id="svg777" xmlns="http://www.w3.org/2000/svg" style={{ height: '3rem' }}>
      <defs id="defs774" />
      <g id="layer1">
        <path
          id="path829"
          d="M 60.854168,121.70833 A 42.333332,42.333332 0 0 1 30.919981,109.30919 42.333332,42.333332 0 0 1 18.520836,79.375 h 42.333332 z"
          style={{ fill: '#ddd6fe', fillOpacity: 1 }}
        />
        <path
          id="path829-2"
          d="m -92.604164,-79.375011 a 42.333332,42.333332 0 0 1 -29.934186,-12.399147 42.333332,42.333332 0 0 1 -12.39915,-29.934182 h 42.333336 z"
          transform="scale(-1)"
          style={{ fill: '#a78bfa', fillOpacity: 1 }}
        />
        <path
          id="path829-5"
          d="M 74.083336,-18.520836 A 42.333332,42.333332 0 0 1 44.149149,-30.919982 42.333332,42.333332 0 0 1 31.750004,-60.854168 h 42.333332 z"
          transform="rotate(90)"
          style={{ fill: '#ede9fe', fillOpacity: 1 }}
        />
        <rect id="rect979" width="21.166666" height="42.333332" x="66.145828" y="31.750002" style={{ fill: '#f5f3ff', fillOpacity: 1, strokeWidth: '0.264583' }} />
        <rect id="rect979-6" width="21.166666" height="42.333332" x="66.145828" y="79.375008" style={{ fill: '#c4b5fd', fillOpacity: 1, strokeWidth: '0.264583' }} />
      </g>
    </svg>
  );
}
